
import Vue from "vue";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import UnitConverter from '../../mixins/unitConverter'
import UserProvisioning from "@/mixins/userProvisioning";

@Component
export default class General extends Mixins(UnitConverter, UserProvisioning) {
  @Prop({})
  dailyReport!:any
  @Prop({})
  project!: any;
  @Prop({})
  fluidTypes!: any;

  @Prop({}) 
  startDepth!:any;
  @Prop({}) 
  last!:any;
  @Prop({}) 
  endDepth!:any;
  @Prop({}) 
  reportDate!:any;
  @Prop({}) 
  startTime!:any;
  @Prop({}) 
  endTime!:any;
  @Prop({}) 
  depthReference!:any;
  @Prop({}) 
  depthReferenceType!:any;

  // Schedule
  @Prop({})
  plannedRigMoveStartDate!:any
  @Prop({})
  plannedRigMoveEndDate!:any
  @Prop({})
  plannedRigMoveDays!:any
  @Prop({})
  plannedOperationsDays!:any
  @Prop({})
  rigMoveStartDate!:any
  @Prop({})
  rigMoveEndDate!:any
  @Prop({})
  actualRigMoveDays!:any
  @Prop({})
  daysOnLocation!:any
  @Prop({})
  spudDate!:any
  @Prop({})
  spudTime!:any
  @Prop({})
  daysFromSpud!:any
  @Prop({})
  operatingDaysVariance!:any

  // Status
  @Prop({})
  dailySummary!:any;
  @Prop({})
  dailyChallenge!:any;
  @Prop({})
  currentStatus!:any;
  @Prop({})
  dailyForecast!:any;

  targetFields: Array<any> = [
      {
          key:"reservoirName",
          label:"Reservoir Name"
      },
      {
          key:"fluidType",
          label:"Fluid Type"
      },
      {
          key:"actualRate",
          label:"Actual Rate"
      },
      {
          key:"actions",
          label:"Actions"
      }
  ]

  enterWelltest: boolean = false;

  private get startDepthInput() {
    return this.startDepth;
  }
  private set startDepthInput(depth:any) {
    this.$emit("update:startDepth", depth);
  }
  private get depthReferenceInput() {
    return this.depthReference;
  }
  private set depthReferenceInput(depth:any) {
    this.$emit("update:depthReference", depth);
  }
  private get depthReferenceTypeInput() {
    return this.depthReferenceType;
  }
  private set depthReferenceTypeInput(depth:any) {
    this.$emit("update:depthReferenceType", depth);
  }
  private get endDepthInput() {
    return this.endDepth;
  }
  private set endDepthInput(depth:any) {
    this.$emit("update:endDepth", depth);
  }
   private get reportDateInput() {
    return this.reportDate;
  }
  private set reportDateInput(date:any) {
    this.$emit("update:reportDate", date);
  }
   private get startTimeInput() {
    return this.startTime;
  }
  private set startTimeInput(time:any) {
    // this.$emit("update:startTime", time);
  }
  private get endTimeInput() {
    return this.endTime;
  }
  private set endTimeInput(time:any) {
    // this.$emit("update:endTime", time);
  }

  // Schedule
  private get plannedRigMoveStartDateInput() {
    return this.plannedRigMoveStartDate;
  }
  private set plannedRigMoveStartDateInput(date:any) {
    this.$emit("update:plannedRigMoveStartDate", date);
  }
  private get actualStartDateInput() {
    return this.rigMoveStartDate;
  }
  private set actualStartDateInput(date:any) {
    this.$emit("update:rigMoveStartDate", date);
  }
  private get plannedEndDateInput() {
    return this.plannedRigMoveEndDate;
  }
  private set plannedEndDateInput(date:any) {
    this.$emit("update:plannedRigMoveEndDate", date);
  }
  private get actualEndDateInput() {
    return this.rigMoveEndDate;
  }
  private set actualEndDateInput(date:any) {
    this.$emit("update:rigMoveEndDate", date);
  }
  private get plannedDaysRigMoveInput() {
    return this.plannedRigMoveDays;
  }
  private set plannedDaysRigMoveInput(date:any) {
    this.$emit("update:plannedRigMoveDays", date);
  }
  private get actualRigMoveDaysInput() {
    return this.actualRigMoveDays;
  }
  private set actualRigMoveDaysInput(date:any) {
    this.$emit("update:actualRigMoveDays", date);
  }
  private get plannedDaysOperationalInput() {
    return this.plannedOperationsDays;
  }
  private set plannedDaysOperationalInput(days:any) {
    this.$emit("update:plannedOperationsDays", days);
  }
  private get operatingDaysVarianceInput() {
    return this.operatingDaysVariance;
  }
  private set operatingDaysVarianceInput(days:any) {
    this.$emit("update:operatingDaysVariance", days);
  }
  private get spudDateInput() {
    return this.spudDate;
  }
  private set spudDateInput(days:any) {
    this.$emit("update:spudDate", days);
  }
  private get spudTimeInput() {
    return this.spudTime;
  }
  private set spudTimeInput(days:any) {
    this.$emit("update:spudTime", days);
  }
  private get daysFromSpudInput() {
    return this.daysFromSpud;
  }
  private set daysFromSpudInput(days:any) {
    this.$emit("update:daysFromSpud", days);
  }
  private get daysOnLocationInput() {
    return this.daysOnLocation;
  }
  private set daysOnLocationInput(days:any) {
    this.$emit("update:daysOnLocation", days);
  }

  // Status
  private get dailySummaryInput() {
    return this.dailySummary;
  }
  private set dailySummaryInput(value:any) {
    this.$emit("update:dailySummary", value);
  }
  private get dailyChallengeInput() {
    return this.dailyChallenge;
  }
  private set dailyChallengeInput(value:any) {
    this.$emit("update:dailyChallenge", value);
  }
  private get currentStatusInput() {
    return this.currentStatus;
  }
  private set currentStatusInput(value:any) {
    this.$emit("update:currentStatus", value);
  }
  private get dailyForecastInput() {
    return this.dailyForecast;
  }
  private set dailyForecastInput(value:any) {
    this.$emit("update:dailyForecast", value);
  }

  get reservoirNames() {
    return this.project && this.project.targets.length ? this.project.targets.map((target: any) => target.name) : []
  }

  get settingswellFluid():Array<any> {
      return this.$store.getters['settingsModule/getSettingsWell']
  }

  get fetchColorSettings():any {
      return this.$store.dispatch('settingsModule/getColorSettings')
  }

  get getWellFluidType():Array<any> {
      let wellTypeOptions: Array<any>=[]
      this.settingswellFluid.forEach((wellType: any)=>{
          wellTypeOptions.push({text:wellType.propertyName,value:wellType.propertyName})
      })
      return wellTypeOptions
  }

  getRateLabel (fluidType: string) {
      switch (fluidType) {
          case 'Oil':
              return 'BOPD';
          case 'Gas':
              return 'MMSCF/D';
          case 'Water':
              return 'BOPD';
          case 'Condensate':
              return 'BOPD';
          default:
              return '';
      }
  }

  getRatePlaceholder (fluidType: string) {
      switch (fluidType) {
          case 'Oil':
              return 'Enter BOPD';
          case 'Gas':
              return 'Enter MMSCF/D';
          case 'Water':
              return 'Enter BOPD';
          case 'Condensate':
              return 'Enter BOPD';
          default:
              return 'Enter rate';
      }
  }

  removeTarget (rate:any){
      const index = this.dailyReport.targets.findIndex((target: any) => target.id == rate.id);
      if (index !== -1) {
          this.dailyReport.targets.splice(index, 1);
      }
  }

  addTarget() {
      let target = {
          id: 0,
          reservoirName:"",
          fluidType: "",
          actualRate: 0
      }
      this.dailyReport.targets.push(target);
  }

  reservoirChanged(name: string, id: number) {
    const target = this.project && this.project.targets.length ? this.project.targets.find((target: any) => target.name === name) : '';
    const welltestRate = this.dailyReport.targets.find((t: any) => t.id === id)
    welltestRate.fluidType = target.fluidType;
    welltestRate.actualRate = target.expectedRate;
  }

  @Watch("dailyReport.targets")
  onTargetsChanged(value: Array<any>) {
    if (value.length)
    {
      this.enterWelltest = true;
    }else {
      this.enterWelltest = false;
    }
  }

  created() {
      if (this.settingswellFluid.length < 1)
          this.fetchColorSettings.then(() => {});
      
    if (this.dailyReport && this.dailyReport.targets && this.dailyReport.targets.length){
      this.enterWelltest = true;
    }else {
      this.enterWelltest = false;
    }
  }
}
